<template>
  <v-dialog
    persistent
    transition="scale-transition"
    :max-width="$vuetify.breakpoint.xsOnly ? '95%' : '300'"
    v-model="this._props.component.dialog"
  >
    <v-card outlined>
      <v-card-title class="text-subtitle-1 pa-3">Qual a quantidade?</v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pa-3 pb-0">
        <v-text-field
          outlined
          dense
          v-model="component.amount"
          label="Quantidade"
          type="number"
          hide-details
        ></v-text-field>
      </v-card-text>
      <v-card-actions
        class="pa-3"
        :style="$vuetify.breakpoint.xsOnly
          ? 'flex-direction: column; gap: 8px;'
          : 'justify-content: flex-end; gap: 8px;'"
      >
        <v-btn
          depressed
          rounded
          :block="$vuetify.breakpoint.xsOnly"
          class="red darken-4 white--text"
          @click="disableDialog"
        >Cancelar</v-btn>
        <v-btn
          rounded
          depressed
          :block="$vuetify.breakpoint.xsOnly"
          class="success"
          @click="component.confirmAlterQuantProduct()"
        >Confirmar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: { component: Object },
  data: () => ({ amount: "" }),
  methods: {
    disableDialog() {
      this._props.component.dialog = !this._props.component.dialog;
    },
  },
};
</script>
